module.exports = __webpack_public_path__ + "static/media/  (165).5cf2d019.jpg";